export const VEZGO_PROVIDER_CATEGORY = {
  EXCHANGES: 'exchanges',
  WALLETS: 'wallets',
  BLOCKCHAINS: 'blockchains',
}
